import SampleReportView from "@/components/samples/SampleReportView";
import { PARADISE_ENERGY_SOLUTIONS_COMMERCIAL_REPORT } from "@/data/sample-reports";

const ParadiseEnergySolutionsCommercialSample = () => (
  <SampleReportView report={PARADISE_ENERGY_SOLUTIONS_COMMERCIAL_REPORT} />
);

export default ParadiseEnergySolutionsCommercialSample;
